import React, { Component } from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

export interface PaginationComponentProps extends WithStyles<typeof STYLES> {
    onPageChange?: (pageNumber: number) => void
    currentPage: number
    totalItemsCount?: number
    itemsCountPerPage?: number
}

interface IState {
    activePage: number
}

class PaginationComponent extends Component<PaginationComponentProps, IState> {

    constructor(props: PaginationComponentProps) {
        super(props);
        this.state = {
            activePage: 1
        };
    }

    // shouldComponentUpdate(nextProps) {
    //     if (!_.isEqual(this.props.totalItemsCount, nextProps.totalItemsCount) || !_.isEmpty(this.props.handlePageChange, nextProps.handlePageChange))
    //         return true
    //     return true
    // }

    componentDidMount = () => {
        this.setState({ activePage: this.props.currentPage });
    }

    handlePageChange = (e: React.ChangeEvent<unknown>, pageNumber: number) => {
        this.setState({ activePage: pageNumber });
        if (typeof this.props.onPageChange === 'function')
            this.props.onPageChange(pageNumber);
    }
    render() {
        const { totalItemsCount = 0, itemsCountPerPage = 10 } = this.props;
        if (totalItemsCount < 1) {
            return (<div></div>)
        }
        return (
            <Pagination
                page={this.state.activePage}
                count={totalItemsCount / itemsCountPerPage}
                onChange={this.handlePageChange}
            />
        )
    }
}

const STYLES = (theme: Theme) => createStyles({

})

export default withStyles(STYLES)(PaginationComponent);